import React, { useEffect, useState } from 'react';
import api from '@/api/axios';
import { Trophy } from '@phosphor-icons/react';

const fmtQ = (n) => `Q ${Number(n || 0).toLocaleString('es-GT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const MEDALS = ['🥇', '🥈', '🥉'];

export const RankingSemanalERP = ({ embedded = false }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get('/harperp/ranking-semanal').then(r => setData(r.data)).catch(() => setError(true));
  }, []);

  if (error) return null;

  const body = (
    <div data-testid="ranking-semanal-erp">
      {!data ? (
        <p className="text-xs text-[var(--text-muted)]">Calculando ranking de la semana…</p>
      ) : (
        <>
          <div className="space-y-1.5 max-h-[380px] overflow-y-auto pr-1">
            {(data.vendedores || []).map(v => (
              <div
                key={v.vendedor}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg ${v.pos <= 3 ? 'bg-amber-500/10 border border-amber-500/25' : 'bg-[var(--surface-muted)]'}`}
                data-testid={`ranking-row-${v.pos}`}
              >
                <span className="w-7 text-center text-sm font-black shrink-0">{MEDALS[v.pos - 1] || `#${v.pos}`}</span>
                <span className="flex-1 text-sm font-bold text-[var(--text)] truncate">{v.vendedor}</span>
                <span className="text-[10px] text-[var(--text-muted)] shrink-0">{v.docs} docs</span>
                <span className="text-sm font-black text-[var(--text)] shrink-0">{fmtQ(v.total)}</span>
              </div>
            ))}
            {(data.vendedores || []).length === 0 && (
              <p className="text-xs text-[var(--text-muted)]">Sin facturación esta semana todavía.</p>
            )}
          </div>
          <p className="text-[10px] text-[var(--text-muted)] mt-2">
            Semana del {data.rango?.desde} · facturación HarpERP CyH + SA · actualizado {data.actualizado}
          </p>
        </>
      )}
    </div>
  );

  if (embedded) return body;

  return (
    <div className="bg-[var(--surface)] border border-[var(--border)] rounded-[14px] p-4 mb-6" data-testid="ranking-semanal-card">
      <div className="flex items-center gap-2 mb-3">
        <Trophy size={18} weight="fill" className="text-amber-500" />
        <h3 className="text-sm font-black uppercase tracking-wider text-[var(--text-muted)]">Ranking de la semana · facturación ERP</h3>
      </div>
      {body}
    </div>
  );
};
